var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunrise0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41667 7.83333H0.5M2.4773 5.2273L1.82912 4.57912M7.68932 5.2273L8.3375 4.57912M9.66667 7.83333H8.75M2.79167 7.83333C2.79167 6.56768 3.81768 5.54167 5.08333 5.54167C6.34899 5.54167 7.375 6.56768 7.375 7.83333M9.66667 9.66667H0.5M6.91667 2.33333L5.08333 0.5M5.08333 0.5L3.25 2.33333M5.08333 0.5V3.70833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise0);
export default __webpack_public_path__ + "static/media/sunrise0.828b0f5c7a7d3d08feb3926740420407.svg";
export { ForwardRef as ReactComponent };